import React from 'react';
import { MinWidth } from '../../../../base';

export default function Mobile({ children }) {
  return (
    <div
      css={MinWidth.sm`
        display: none;`}
    >
      {children}
    </div>
  );
}
